export var DEFAULT_LOGIN_STRATEGY='basic';export var EVENT_USER_INITIALIZED='EVENT_USER_INITIALIZED';